import "./MaintenancePage.css";
import DigiGabLogo from "./Assets/digigab_full_logo_color.png";

function MaintenancePage() {
  return (
    <main className="maintenance-page">
      <div className="maintenance-glow maintenance-glow-left" aria-hidden="true" />
      <div className="maintenance-glow maintenance-glow-right" aria-hidden="true" />

      <section
        className="maintenance-content"
        aria-labelledby="maintenance-title"
      >
        <img
          className="maintenance-logo"
          src={DigiGabLogo}
          alt="DigiGab Technologies Solutions"
        />

        <div className="maintenance-divider" aria-hidden="true" />

        <h1 id="maintenance-title">
          DigiGab Technologies
          <br />
          Solutions évolue.
        </h1>

        <p className="maintenance-message">
          Nous construisons une nouvelle expérience pour aider les entreprises
          à comprendre leur situation digitale et à décider de leur prochaine
          évolution.
        </p>

        <p className="maintenance-return">De retour bientôt.</p>

        <div className="maintenance-divider" aria-hidden="true" />

        <a
          className="maintenance-contact"
          href="mailto:hello@digigab.io"
          aria-label="Écrire à DigiGab"
        >
          <span className="maintenance-mail-icon" aria-hidden="true">
            ✉
          </span>
          <span>hello@digigab.io</span>
        </a>

        <p className="maintenance-year">2026</p>
      </section>
    </main>
  );
}

export default MaintenancePage;